import {gsap} from 'gsap'

if (window.innerWidth > 1000) {

  var ease = 0.6;
  var group = $("#cursor-group");
  var pos = { x: 0, y: 0 };
  var mouse = { x: 0, y: 0 };

  var setX = gsap.quickSetter(group, "x");
  var setY = gsap.quickSetter(group, "y");
  gsap.set(group, { scale: 0, transformOrigin: "50% 50%" });

  group.fadeOut()

// FIX to one global variable
  let activeCursor = $('a, .cursor-animation')

    .on("mouseenter", function (e) {
      group.fadeIn()
      setX(e.clientX);
      setY(e.clientY);
      mouse.x = pos.x = e.clientX;
      mouse.y = pos.y = e.clientY;
      gsap.to(group, { scale: 1 });
    })

  activeCursor.on("mouseleave", function (e) {
    gsap.to(group, { scale: 0 });
  })

  $(window).on("mousemove", function (e) {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
  })

  gsap.ticker.add(update);

  function update () {
    pos.x += (mouse.x - pos.x) * ease;
    pos.y += (mouse.y - pos.y) * ease;

    setX(pos.x);
    setY(pos.y);
  }

}

// import { gsap } from 'gsap';
//
// // Linear interpolation
// const lerp = (a, b, n) => (1 - n) * a + n * b;
//
// // Gets the mouse position
// const getMousePos = e => {
//   return {
//     x : e.clientX,
//     y : e.clientY
//   };
// };
//
//
// // Track the mouse position
// let mouse = {x: 0, y: 0};
// window.addEventListener('mousemove', ev => mouse = getMousePos(ev));
//
// export default class Cursor {
//   constructor(el) {
//     this.DOM = {el: el};
//     this.DOM.el.style.opacity = 0;
//
//     this.bounds = this.DOM.el.getBoundingClientRect();
//
//     this.renderedStyles = {
//       tx: {previous: 0, current: 0, amt: 0.2},
//       ty: {previous: 0, current: 0, amt: 0.2},
//       scale: {previous: 1, current: 1, amt: 0.2},
//       opacity: {previous: 1, current: 1, amt: 0.2}
//     };
//
//     this.onMouseMoveEv = () => {
//       this.renderedStyles.tx.previous = this.renderedStyles.tx.current = mouse.x - this.bounds.width/2;
//       this.renderedStyles.ty.previous = this.renderedStyles.ty.previous = mouse.y - this.bounds.height/2;
//       gsap.to(this.DOM.el, {duration: 0.9, ease: 'Power3.easeOut', opacity: 1});
//       requestAnimationFrame(() => this.render());
//       window.removeEventListener('mousemove', this.onMouseMoveEv);
//     };
//     window.addEventListener('mousemove', this.onMouseMoveEv);
//   }
//   enter() {
//     this.renderedStyles['scale'].current = 5;
//     this.renderedStyles['opacity'].current = 0.2;
//   }
//   leave() {
//     this.renderedStyles['scale'].current = 1;
//     this.renderedStyles['opacity'].current = 1;
//   }
//   render() {
//     this.renderedStyles['tx'].current = mouse.x - this.bounds.width/2;
//     this.renderedStyles['ty'].current = mouse.y - this.bounds.height/2;
//
//     for (const key in this.renderedStyles ) {
//       this.renderedStyles[key].previous = lerp(this.renderedStyles[key].previous, this.renderedStyles[key].current, this.renderedStyles[key].amt);
//     }
//
//     this.DOM.el.style.transform = `translateX(${(this.renderedStyles['tx'].previous)}px) translateY(${this.renderedStyles['ty'].previous}px) scale(${this.renderedStyles['scale'].previous})`;
//     this.DOM.el.style.opacity = this.renderedStyles['opacity'].previous;
//
//     requestAnimationFrame(() => this.render());
//   }
// }
//
// const cursor = new Cursor(document.querySelector('.cursor'))
//
// $("a, .cursor-animation").mouseenter(function(){
//   cursor.enter()
// })
// $("a, .cursor-animation").mouseleave(function(){
//   cursor.leave()
// })
